module.exports = __webpack_public_path__ + "static/media/masthead-albany-advertiser.7cf3c1be.png";